import Vue from 'vue';
import Vuex from 'vuex';
// FIXME import/no-cycle
import patentView from './modules/patent-view'; // eslint-disable-line
import chemical from './modules/chemical-highlight';
import bio from './modules/bio-highlight';
import dual from './modules/dual';

import root from './modules/root';

Vue.use(Vuex);

export const store = new Vuex.Store({
    modules: {
        root,
        chemical,
        patentView,
        bio,
        dual,
    }
});

export default store;